import config from '../config';
import selectedEnvironment from '../env';

const API_URL = `${config[selectedEnvironment].API_URL}/Salaries`;

/** Fired on window after a client's salary settings were saved; detail: { caseId }. */
export const SALARY_SETTINGS_SAVED_EVENT = 'salaries:settingsSaved';

/** Matches the server's SalaryCodeSourceType. */
export const SALARY_SOURCE = {
    ACCOUNT_CARDS: 1,
    SORT_CODES: 2,
};

const handleResponse = async (response) => {
    if (!response.ok) {
        const errorText = await response.text();
        throw new Error(errorText || `HTTP ${response.status}`);
    }
    return response.json();
};

const post = async (path, body, token) =>
    handleResponse(await fetch(`${API_URL}/${path}`, {
        method: 'POST',
        headers: {
            Authorization: 'Bearer ' + token,
            'Content-Type': 'application/json',
        },
        body: JSON.stringify(body),
    }));

const getSettings = ({ caseId }, token) => post('GetSettings', { caseId }, token);

/** `salaries` / `socialBenefits`: `{ sourceType, codes }`. Returns the saved settings. */
const saveSettings = ({ caseId, salaries, socialBenefits, filterByDocumentDate }, token) =>
    post('SaveSettings', { caseId, salaries, socialBenefits, filterByDocumentDate }, token);

/**
 * Monthly totals and statuses of the years `startYear`..`endYear`, plus each category's total for the
 * `periodStart`..`periodEnd` months and the past months without data.
 */
const getOverview = ({ caseId, startYear, endYear, periodStart = null, periodEnd = null }, token) =>
    post('GetOverview', { caseId, startYear, endYear, periodStart, periodEnd }, token);

const SalariesService = {
    getSettings,
    saveSettings,
    getOverview,
};

export default SalariesService;
